import { Outlet } from 'react-router';

import { BUYER_ROUTES } from './buyer.routes';
import { DEMO_ROUTES } from './demo.routes';
import { SELLER_ROUTES, redirectRoutes } from './seller.routes';
import { normaliseContainerRoutes } from './utils';
import { AppWrapper } from '../AppWrapper';

export const routes = [
  {
    element: (
      <AppWrapper>
        <Outlet />
      </AppWrapper>
    ),
    children: [
      {
        path: '/pay',
        children: [
          ...normaliseContainerRoutes(SELLER_ROUTES),
          ...normaliseContainerRoutes(BUYER_ROUTES),
          ...normaliseContainerRoutes(DEMO_ROUTES),
          ...redirectRoutes,
        ],
      },
    ],
  },
];
